/**
 * Maps event categories to D3 symbol types and Lucide icon names.
 * Used by the timeline renderer for visual differentiation of event categories.
 */

import {
  symbolCircle,
  symbolTriangle,
  symbolDiamond,
  symbolSquare,
  symbolCross,
  type SymbolType,
} from 'd3';
import type { EventCategory } from '../../constants/eventCategories';

/**
 * Returns the D3 symbol type for a given event category.
 * - PM: cross (wrench-like)
 * - CM: triangle (alert)
 * - Asset Update: diamond
 * - Upcoming: square
 * - Other: circle (default)
 */
export function getCategorySymbol(category: EventCategory): SymbolType {
  switch (category) {
    case 'preventative_maintenance':
      return symbolCross;
    case 'corrective_maintenance':
      return symbolTriangle;
    case 'asset_update':
      return symbolDiamond;
    case 'upcoming':
      return symbolSquare;
    case 'other':
    default:
      return symbolCircle;
  }
}

/**
 * Returns the Lucide icon name for a given event category.
 * Used in React UI components (filter chips, legends).
 */
export function getCategoryIconName(category: EventCategory): string {
  switch (category) {
    case 'preventative_maintenance':
      return 'Wrench';
    case 'corrective_maintenance':
      return 'AlertTriangle';
    case 'asset_update':
      return 'RefreshCw';
    case 'upcoming':
      return 'CalendarClock';
    case 'other':
    default:
      return 'Circle';
  }
}
